export function readPath(obj: unknown, path: string): unknown {
  return path.split('.').reduce<unknown>((acc, part) => {
    const m = /^([^[]+)(?:\[(\d+)\])?$/.exec(part);
    if (!m || acc == null) return undefined;
    const [, key, indexStr] = m;
    const next = (acc as Record<string, unknown>)[key];
    return indexStr !== undefined ? (next as unknown[])?.[Number(indexStr)] : next;
  }, obj as unknown);
}
